import RadioButton from '@base/RadioButton/RadioButton';
import styled from '@emotion/styled';
import CheckedRadio from '@icon/CheckedRadio';
import EmptyRadio from '@icon/EmptyRadio';
import { Fonts, Spacings } from '@styles/index';
import { getLabelForTimeinDay } from '@utils/dates';
import { FC } from 'react';
import { AnyArgVoidReturnFunction } from 'types/utils';

const timeArray = [
  6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 1, 2,
  3, 4, 5
];

const RadioWrapper = styled.div`
  margin: ${Spacings.SPACING_10B} 0;
  height: 352px;
  position: relative;
  overflow: auto;
  scrollbar-width: ${Spacings.SPACING_6};
  ::-webkit-scrollbar {
    width: ${Spacings.SPACING_2B};
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    width: ${Spacings.SPACING_6};
    border-radius: ${Spacings.SPACING_10B};
    background: transparent;
  }

  &:hover {
    ::-webkit-scrollbar-thumb {
      background: var(--color-text-secondary);
    }
  }
`;

const Radio = styled(RadioButton)<any>`
  .MuiButtonBase-root {
    color: var(--color-divider);
    margin-block-start: auto !important;
    margin-right: 14px !important;
  }
  .MuiTypography-body1 {
    font-size: ${Fonts.P1};
    font-weight: ${Fonts.SEMIBOLD};
  }

  .Mui-checked {
    color: var(--color-text-primary);
  }

  padding-right: 0px;
  margin-right: ${Spacings.SPACING_2B};
  color: var(--color-text-primary);
`;

const RadioGroup = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  margin-bottom: 34px;
  z-index: 2;
`;

interface ICourseTimeSelectorProps {
  selectedChoice: any;
  onChange: AnyArgVoidReturnFunction;
}

const CourseTimeSelector: FC<ICourseTimeSelectorProps> = ({
  selectedChoice,
  onChange
}) => {
  return (
    <RadioWrapper>
      {timeArray.map((item) => {
        const numberOfMinutes = item === 24 ? 0 : item * 60;
        const isSelected = selectedChoice === numberOfMinutes;
        return (
          <RadioGroup key={item} onClick={() => onChange(numberOfMinutes)}>
            <Radio
              checked={isSelected}
              isSelected={isSelected}
              label={getLabelForTimeinDay(item)}
              icon={<EmptyRadio size="24px" color="var(--color-divider)" />}
              checkedIcon={
                <CheckedRadio size="24px" color="var(--color-text-primary)" />
              }
            />
          </RadioGroup>
        );
      })}
    </RadioWrapper>
  );
};

export default CourseTimeSelector;
